import { render, staticRenderFns } from "./ActionUploadData.vue?vue&type=template&id=74d0dbd2&lang=pug"
import script from "./ActionUploadData.vue?vue&type=script&lang=js"
export * from "./ActionUploadData.vue?vue&type=script&lang=js"
import style0 from "./ActionUploadData.vue?vue&type=style&index=0&id=74d0dbd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports